import { Button, UIHeading4, UIText2, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import styles from './AreaPartCreateBlock.css';
import { IAreaPartCreateBlockProps } from './types';

export const AreaPartCreateBlock: React.FC<IAreaPartCreateBlockProps> = props => {
  const { onClick } = props;

  const isMobile = useDeviceType() === 'phone';

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading4>Создайте Мультиобъявление, если у вас несколько площадей в одном здании</UIHeading4>
        <div className={styles['description']}>
          <UIText2>Такое объявление показывается чаще в результатах поиска, выглядит крупнее и привлекательнее</UIText2>
        </div>
        <Button size={isMobile ? 'M' : 'XS'} onClick={onClick} type="button">
          Создать мультиобъявление
        </Button>
      </div>
      {!isMobile && <div className={styles['image']} />}
    </div>
  );
};
